"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Toastr = require("react-toastr");
var ToastMessageFactory = React.createFactory(Toastr.ToastMessage.animation);
require("./Toaster.css");
/**
 * A wrapper around react-toastr
 */
var Toaster = (function (_super) {
    __extends(Toaster, _super);
    /**
     * Toaster constructor
     * @param props
     */
    function Toaster(props) {
        var _this = _super.call(this, props) || this;
        _this._bindElement = _this._bindElement.bind(_this);
        _this.notify = _this.notify.bind(_this);
        return _this;
    }
    /**
     * Bind toastr reference to a variable.
     * @param input
     */
    Toaster.prototype._bindElement = function (input) {
        this.container = input;
    };
    /**
     * Get the icon class name.
     * @param type
     */
    Toaster.prototype._getIcon = function (type) {
        switch (type) {
            case "success":
                return "p-icon-check";
            case "warning":
                return "p-icon-alert-triangle";
            case "error":
                return "p-icon-alert-round-2";
            case "info":
                return "p-icon-alert-round-1";
            default:
                return "";
        }
    };
    Toaster.prototype._getColor = function (type) {
        switch (type) {
            case "success":
                return "p-bg-success50";
            case "warning":
                return "p-bg-warning50";
            case "error":
                return "p-bg-error50 ";
            case "info":
                return "p-bg-info50";
            default:
                return "";
        }
    };
    /**
     * Public method to instantiate toastr messages.
     * @param type type of notification - success, info, error, warning
     * @param title title of notification
     * @param message message underneath the title
     * @param opts additional options
     */
    Toaster.prototype.notify = function (type, title, message, opts) {
        var defaultOpts = {
            className: "p-toaster-box",
            timeOut: this.props.timeOut || 5000,
            extendedTimeOut: this.props.extendedTimeOut || 5000,
            showAnimation: "animated fadeIn",
            hideAnimation: "animated fadeOut"
        };
        var args = [
            message ? (React.createElement("div", { className: "toast-message p-toaster-title" },
                React.createElement("div", { className: "p-toaster-icon-container " + this._getColor(type) },
                    React.createElement("i", { className: "p-toaster-title__icon", "aria-hidden": "true" })),
                React.createElement("div", { className: "p-toaster-msg" }, message))) : null,
            (React.createElement("div", { className: "p-toaster-title" },
                React.createElement("div", { className: "p-toaster-icon-container " + this._getColor(type) },
                    React.createElement("i", { className: "p-toaster-title__icon " + this._getIcon(type) + " p-f-sz-md", "aria-hidden": "true" })),
                React.createElement("div", { className: "p-toaster-title__msg" }, title)))
        ];
        switch (type) {
            case "success":
                defaultOpts.className += " p-toaster-message__success";
                args.push(__assign({}, defaultOpts, opts));
                this.container && (_a = this.container).success.apply(_a, args);
                break;
            case "error":
                defaultOpts.className += " p-toaster-message__error";
                args.push(__assign({}, defaultOpts, opts));
                this.container && (_b = this.container).error.apply(_b, args);
                break;
            case "info":
                defaultOpts.className += " p-toaster-message__info";
                args.push(__assign({}, defaultOpts, opts));
                this.container && (_c = this.container).info.apply(_c, args);
                break;
            case "warning":
                defaultOpts.className += " p-toaster-message__warning";
                args.push(__assign({}, defaultOpts, opts));
                this.container && (_d = this.container).warning.apply(_d, args);
                break;
            default:
                break;
        }
        var _a, _b, _c, _d;
    };
    Toaster.prototype.render = function () {
        return (React.createElement("div", { "data-tag": this.props.tag, className: "p-toaster" },
            React.createElement(Toastr.ToastContainer, { ref: this._bindElement, className: "toast-top-center", toastMessageFactory: ToastMessageFactory, preventDuplicates: false })));
    };
    return Toaster;
}(React.Component));
/**
 * default properties
 */
Toaster.defaultProps = {
    timeOut: 5000,
    extendedTimeOut: 5000,
    tag: null
};
exports.default = Toaster;
//# sourceMappingURL=Toaster.js.map


//////////////////
// WEBPACK FOOTER
// ../player-toaster/build/control/Toaster.js
// module id = 81
// module chunks = 0 1 2